import _ from 'lodash'
import * as query from '@/queries/pendingProduct'
import utils from '@/store/utils'

export const defaultState = function () {
  return {
    returnList: false, // 一覧から呼び出された詳細画面であるか
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'pending_product_list',
    searchConditions: {}
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    update (state, data) {
      const rowData = utils.pick(data, utils.createKeys(query.GRAPH_QL_QUERY_PENDING_PRODUCT_LIST, 1))
      _.forEach(state.tdLists, (val, index) => {
        if (val.uuid === data.uuid) {
          _.merge(state.tdLists[index], _.cloneDeep(rowData))
        }
      })
    },
    delete (state, uuid) {
      _.remove(state.tdLists, (val) => val.uuid === uuid)
    }
  },
  getDefaultState: defaultState
}
